var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "u-flex u-row-between u-col-center",
                      staticStyle: { height: "42px" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "u-font-weight-bold u-font-18" },
                        [_vm._v("共同被保险人")]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: { effect: "light", placement: "top" },
                          scopedSlots: _vm._u([
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "white-space": "pre-line",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t同一人通过亲属实际控制多个网点、网点间 代结、上下级网点关系，如有上述共同被保 险企业应在投保时列明\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm.isShowAddBtn
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-plus",
                                    type: "primary",
                                  },
                                  on: { click: _vm.onAddUnits },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t增加共同被保险人\n\t\t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          !_vm.isShowAddBtn
            ? _c(
                "div",
                [
                  _c("el-empty", {
                    staticClass: "u-font-18 u-font-weight-bold",
                    attrs: {
                      "image-size": 80,
                      description: "确认投保企业后，才能新增公共被保险人！",
                    },
                  }),
                ],
                1
              )
            : _c("avue-crud", {
                ref: "refInsured",
                attrs: { data: _vm.insuredData, option: _vm.optionInsured },
                on: { "row-del": _vm.onRowDel },
              }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.isShowAddDialog },
          on: {
            "update:visible": function ($event) {
              _vm.isShowAddDialog = $event
            },
          },
        },
        [
          _c("FormUnitNew", {
            ref: "refUnit",
            staticClass: "u-m-b-20",
            attrs: {
              applicantFormData: _vm.applicantFormData,
              "from-type": 4,
              "insure-type": _vm.insureType,
              productId: _vm.productId,
              sourceProductId: _vm.sourceProductId,
            },
            on: { onSubmittedData: _vm.onSubmittedDataM },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }